module.exports = __webpack_public_path__ + "static/img/3-select-exchange-order-goods.3388749.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/3-select-exchange-order-goods.png
// module id = 1337
// module chunks = 0